import { Dialog, DialogContent, DialogTitle, Stack, Typography } from "@mui/material";
import { format } from "date-fns";
import React from "react";

const IndividualBreachDiscoveredModal = (props) => {

	const handleClose = () => {
		props.onClose()
	};
	
	return (
		<Dialog
			open={props.breach? true : false}
			onClose={handleClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			fullWidth={true}
			maxWidth="sm"
		>
			<DialogTitle id="alert-dialog-title">
				{(props.breach)? props.breach.name : ""}
			</DialogTitle>
			<DialogContent>
				{(props.breach)?
					<Stack direction="column" spacing={2}>
						<Typography>
							<span style={{ fontWeight: "bold", marginRight: "1em" }}>{`Date:`}</span>
							{`${format(props.breach.date, "MM-yyyy")}`}
						</Typography>
						<Typography>
							<span style={{ fontWeight: "bold", marginRight: "1em" }}>{`Count:`}</span>
							{props.breach.count}
						</Typography>
						<Stack direction="column">
							<Typography sx={{ marginBottom: "0.5em" }}>
								<span style={{ fontWeight: "bold", marginRight: "1em" }}>{`Compromised Data:`}</span>
							</Typography>
							{props.breach.compromisedDatas.map((compromisedData, i) => {
								return (
									<Typography sx={{ marginLeft: "2em" }} key={`compromisedData${i}`}>
										{compromisedData}
									</Typography>
								);
							})}
						</Stack>
					</Stack>
				: <React.Fragment/>
				}
			</DialogContent>
		</Dialog>
	);

}

export default IndividualBreachDiscoveredModal;